import React, { useEffect, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { Search } from "lucide-react";

const AgeingTable = ({ tableData }) => {
  const [searchAccountTerm, setSearchAccountTerm] = useState("");
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [viewMore, setViewMore] = useState(false);
  const [filteredTableData, setFilteredTableData] = useState(tableData);

  useEffect(() => {
    if (!searchAccountTerm) {
      setFilteredTableData(tableData || []);
      return;
    }
    const term = searchAccountTerm.toLowerCase();
    const searchedTableData = tableData?.filter((row) =>
      Object.values(row).some(
        (val) =>
          val != null &&
          String(val).toLowerCase().includes(term),
      ),
    );
    setFilteredTableData(searchedTableData);
  }, [searchAccountTerm, tableData]);

  const clearSearch = () => {
    setSearchAccountTerm("");
  };

  return (
    <div>
      {/* Search Bar */}
      {/* <div className="flex justify-between items-center sticky top-0 mb-6 z-10 py-2">
        <div className="relative ml-4 flex items-center shadow pr-1 rounded w-[50%] bg-white">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            className="pl-10 pr-4 py-2 w-full rounded-lg outline-none border-none focus:ring-0"
            type="text"
            placeholder="Search here ..."
            value={searchAccountTerm}
            onChange={(e) => setSearchAccountTerm(e.target.value)}
          />
          {searchAccountTerm !== "" && (
            <button
              className="absolute right-3 rounded text-gray-800"
              onClick={clearSearch}
            >
              <ClearIcon fontSize="small" />
            </button>
          )}
        </div>
      </div> */}

      {/* Header Container */}
      <div className="flex items-center justify-between bg-slate-900 text-white p-3 rounded-t-xl border border-slate-800 shadow-md">
        <h2 className="text-lg font-bold uppercase tracking-wide text-white whitespace-nowrap">
          Ageing Statement
        </h2>
      </div>

      {/* Scrollable Table */}
      <div className="overflow-y-auto max-h-[72vh] border border-slate-200 rounded-b-lg shadow-sm bg-white">
        <table className="min-w-full border-separate border-spacing-0 text-slate-700">
          <thead className="bg-slate-100/90 backdrop-blur sticky top-0 z-10 border-b border-slate-200 [&_th]:whitespace-nowrap">
            <tr className="text-xs uppercase font-semibold tracking-wider text-slate-600">
              {/* <th className="border pl-1 text-sm text-left  font-normal">
                ACCOUNT
              </th>
              <th className="border pl-1 text-sm text-left font-normal">
                AMOUNT
              </th>
              <th className="border pl-1 text-sm text-left w-[245px] font-normal">
                NAME
              </th> */}
              <th className="px-3 py-2.5 text-right border-b border-r border-slate-200 bg-sky-50/50 text-sky-900">0-30</th>
              <th className="px-3 py-2.5 text-right border-b border-r border-slate-200 bg-emerald-50/50 text-emerald-900">31-60</th>
              <th className="px-3 py-2.5 text-right border-b border-r border-slate-200 bg-amber-50/50 text-amber-900">61-90</th>
              <th className="px-3 py-2.5 text-right border-b border-r border-slate-200 bg-orange-50/50 text-orange-900">91-120</th>
              <th className="px-3 py-2.5 text-right border-b border-r border-slate-200 bg-rose-50/50 text-rose-900">121-150</th>
              <th className="px-3 py-2.5 text-right border-b border-slate-200 bg-red-100/50 text-red-950">{'150>'}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 text-sm">
            {filteredTableData?.length > 0 ? (
              filteredTableData?.map((row, i) => (
                <tr
                  key={i}
                  className={`hover:bg-slate-100/70 transition-colors even:bg-slate-50/50 ${
                    selectedLeads.includes(row.Job_id) ? "bg-blue-100" : ""
                  }`}
                >
                  {/* <td className="text-sm border px-3 py-2">{row.ACCOUNT}</td>
                  <td className="text-sm border px-3 py-2">{row.AMOUNT}</td>
                  <td className="text-sm border px-3 py-2">{row.NAME}</td> */}
                  <td className="px-3 py-2 text-right font-mono tabular-nums border-r border-slate-100 bg-sky-50/30 text-sky-800 font-medium">{row.P1}</td>
                  <td className="px-3 py-2 text-right font-mono tabular-nums border-r border-slate-100 bg-emerald-50/30 text-emerald-800 font-medium">{row.P2}</td>
                  <td className="px-3 py-2 text-right font-mono tabular-nums border-r border-slate-100 bg-amber-50/30 text-amber-800 font-medium">{row.P3}</td>
                  <td className="px-3 py-2 text-right font-mono tabular-nums border-r border-slate-100 bg-orange-50/30 text-orange-800 font-medium">{row.P4}</td>
                  <td className="px-3 py-2 text-right font-mono tabular-nums border-r border-slate-100 bg-rose-50/30 text-rose-800 font-medium">{row.P5}</td>
                  <td className="px-3 py-2 text-right font-mono tabular-nums bg-red-50/40 text-red-700 font-semibold">{row.P6}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={9}
                  className="text-center py-12 text-slate-400"
                >
                  <Search className="w-10 h-10 text-slate-300 mb-2 mx-auto" />
                  <p className="text-base font-medium text-slate-700 mb-0.5">
                    No data available
                  </p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AgeingTable;